import getShorterText from "Common/componentUtils/getShorterText";
export default {
    SELECT_FILE: "Выберите файл, чтобы просмотреть его",
    UNKNOWN_FILE: "Неизвестный формат файла",
    DELETE_FILE: "Удалить файл",
    DOWNLOAD: "Скачать файл",
    getConfirmDeleteText: (fileName) => `Вы уверены, что хотите удалить файл "${getShorterText(fileName, 40)}"?`,
    CONFIRMDELETETEXT: "Вы уверены, что хотите удалить файл?"
};
